import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-error-state',
  standalone: false,
  templateUrl: './error-state.component.html',
  styleUrls: ['./error-state.component.scss']
})
export class ErrorStateComponent {
  title = input<string>('Er is iets misgegaan');
  message = input<string>('');
  buttonText = input<string>('Terug');
  iconName = input<string>('error_outline');
  buttonClick = output<void>();

  onButtonClick(): void {
    this.buttonClick.emit();
  }
}
